<app-page inTutorial="true">
  <diamond-tutorial></diamond-tutorial>
</app-page>
